import { IStripePlanFieldsFragment } from "~/lib/queries/fragments/__generated__/StripePlanFields.generated";
import { ICompanyPlanUsageFieldsFragment } from "~/lib/queries/fragments/__generated__/CompanyPlanUsageFields.generated";

export default function hasSufficedAllDowngradeRequirements(
  toPlan: IStripePlanFieldsFragment | "BASIC",
  planUsage: ICompanyPlanUsageFieldsFragment,
) {
  if (toPlan === "BASIC") {
    return (
      planUsage.enrichedProducts === 0 &&
      planUsage.groupInvitations === 0 &&
      planUsage.products <= 20 &&
      planUsage.productsWithMultipleTags === 0 &&
      planUsage.sharingPage === false &&
      planUsage.teamMembers === 1
    );
  }

  if (!toPlan.limits.sharingPage && planUsage.sharingPage) {
    return false;
  }

  return (
    planUsage.enrichedProducts <= toPlan.limits.enrichedProducts &&
    planUsage.groupInvitations <= toPlan.limits.groupInvitations &&
    planUsage.products <= toPlan.limits.products &&
    planUsage.projectsThisMonth <= toPlan.limits.projectsPerMonth &&
    planUsage.teamMembers <= toPlan.limits.teamMembers
  );
}
